import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { ListItemButton, Typography, Dialog, Button } from "@mui/material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {getAllPickingOrders} from "../../utilityFunctions/WarehouseUtil.js";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import Colors from "../../components/ui/Colors";
import swal from 'sweetalert';

const dateOptions = {
    // weekday: "short",
    day: "numeric",
    month: "numeric",
    year: "numeric",
};

const cssLoader = css`
    display: block;
    margin-left: auto;
    margin-right: auto;
`;

export default function PickingOrdersReport(props) {

    const{loginUser} = props;

    const[pickingOrders, setPickingOrders] = useState("");
    const[loading, setLoading] = useState(false);

    const pickingTypes = [
        {
            value: "employeeSale",
            label: "Venta Colaborador"
        },
        {
            value: "webSale",
            label: "Venta Web"
        },
        {
            value: "remission",
            label: "Remisión"
        },
        {
            value: "other",
            label: "Otro"
        }
    ];

    useEffect(() => {
        const initialData = async () => {
            await loadInitialData();
        }
        initialData();
    }, []);

    const loadInitialData = async () => {
        setLoading(true);
        const data = await getAllPickingOrders(loginUser.jwtToken);
        setLoading(false);

        if(!data){
            swal({
                title: "Error",
                text: "No se pudieron obtener las órdenes de picking",
                icon: "error",
            });
            return;
        }

        data.sort((a, b) => {
            const dateA = new Date(a.createdAt);
            const dateB = new Date(b.createdAt);
            return dateB - dateA; // Sort in descending order (newest first)
        });

        setPickingOrders(data);
        
    }

    const[pickingExplanationBox, setPickingExplanationBox] = useState(false);
    const[pickingExplanation, setPickingExplanation] = useState("");

    const renderExplanation = (pickingOrder) => {
        setPickingExplanationBox(true);
        setPickingExplanation(pickingOrder.explanation);
    }

    const closePickingExplanationBox = () => {
        setPickingExplanationBox(false);
    }
    
    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    // flex: 1,
                    justifyContent: "center",
                    alignItems: {xs: "start", sm: "start"},
                    width: "90%",
                    height: "100%",
                    textAlign: "center",
                    overflowY: "scroll",
                }}
            >
            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> : 
            <>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                        <Grid container sx={{marginTop: "1rem"}}>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Código Picking</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Código Estiba</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Fecha</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Cantidad</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Concepto</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    {pickingOrders &&
                        <Grid item xs={12} sm={12} md={12}>
                            <List>
                                {pickingOrders.map((pickingOrder) => (
                                    <ListItem key={pickingOrder.id} sx={{display: "flex", justifyContent: "center", alignItems: "center"}} divider>
                                        <ListItemButton onClick={() => renderExplanation(pickingOrder)}>
                                            <Grid container>
                                                <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                                                    <Typography variant="body2" sx={{color: "black"}}>{pickingOrder.id}</Typography>
                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                                                    <Typography variant="body2" sx={{color: "black"}}>{pickingOrder.batchId}</Typography>
                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                                                    <Typography variant="body2" sx={{color: "black"}}>{new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(pickingOrder.createdAt))}</Typography>
                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                                                    <Typography variant="body2" sx={{color: "black"}}>{pickingOrder.amount}</Typography>
                                                </Grid>
                                                <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                                                    <Typography variant="body2" sx={{color: "black"}}>{pickingTypes.find(type => type.value === pickingOrder.concept)?.label}</Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>
                    }
                </Grid>

                <Dialog open={pickingExplanationBox} onClose={closePickingExplanationBox}
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: {xs: "80%", sm: "50%", md: "40%"},
                                height: "30%"
                            },
                        },
                    }}
                >
                    <Grid container spacing={1} sx={{width: "100%", height: "100%", alignItems: "center", justifyContent: "center"}}>   
                        <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center", textAlign: "center"}}>
                            <Typography variant="h5">Explicación</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} sx={{display: "block", textAlign: "center", padding: "0 20px", maxHeight: "150px", overflow: "auto"}}>
                            <Typography variant="body2" sx={{color: "black"}}>{pickingExplanation}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} sx={{display: "flex", justifyContent: "center"}}>
                            <Button onClick={closePickingExplanationBox} variant="contained" sx={{backgroundColor: Colors.primary,}}>
                                Cerrar
                            </Button>
                        </Grid>
                    </Grid>
                </Dialog>
            </>
            }
            </Box>
        </Box>
    )
}
